import $ from 'jquery';

class FormHelper {
    constructor() {
        // Duration for which user must not type anything in order for the form to be submitted.
        this.KEY_UP_DEBOUNCE_DURATION = 800;
    }

    init() {}

    bindEvents() {}

    /**
     * Registers event listeners and updates the form upon changes of the form data.
     * @param {object} config Configuration object.
     * @param {string} config.formId ID of the form element.
     * @param {string} config.targetAttributeName Data attribute of element that is used to be replaced by HTML received from the server.
     * @param {string} config.unobservedAttributeName Data attribute which marks an input as not being observed for changes.
     */
    registerEventListeners(config) {
        if (!config || !config.formId || !config.targetAttributeName || !config.unobservedAttributeName) {
            throw new Error('Invalid configuration passed.');
        }

        let writeableTypes = ['email', 'number', 'password', 'search', 'tel', 'text', 'time'];

        let observedForm = document.getElementById(config.formId);
        if (!(observedForm && observedForm.getAttribute(config.targetAttributeName))) {
            return;
        }

        for (let i = 0; i < observedForm.length; i += 1) {
            let observedFormElement = observedForm.elements[i];
            let handleElement = !observedFormElement.hasAttribute(config.unobservedAttributeName)
                && observedFormElement.type !== 'submit';

            if (handleElement) {
                let isWriteableElement = (observedFormElement.tagName === 'INPUT' && writeableTypes.indexOf(observedFormElement.type) !== -1) || observedFormElement.tagName === 'TEXTAREA';

                if (isWriteableElement) {
                    observedFormElement.previousValue = observedFormElement.value;

                    observedFormElement.addEventListener('keyup', this.debounce((e) => {
                        setTimeout(() => {
                            if (!observedForm.updating && e.target.previousValue !== e.target.value) {
                                observedForm.keyupUpdate = true;
                                this.updateForm(observedForm, e.target);
                            }
                        }, 0);
                    }, KEY_UP_DEBOUNCE_DURATION));

                    observedFormElement.addEventListener('blur', (e) => {
                        setTimeout(() => {
                            if (!observedForm.updating && e.target.previousValue !== e.target.value) {
                                this.updateForm(observedForm, e.relatedTarget);
                            }
                        }, 0);
                    });
                }

                observedFormElement.addEventListener('change', (e) => {
                    setTimeout(() => {
                        if (!observedForm.updating) {
                            this.updateForm(observedForm);
                        }
                    }, 0);
                });
            }
        }
    }

    /**
     * Updates the form markup.
     * @param {HTMLElement} form Element of the form to update.
     * @param {Element} nextFocusElement Element which shout get focus after update.
     */
    updateForm(form, nextFocusElement) {
        if (!form) {
            return;
        }

        // If form is not updatable then do nothing
        let elementIdSelector = form.getAttribute('data-ktc-ajax-update');
        if (!elementIdSelector) {
            return;
        }

        $(form).find('input[type="submit"]').attr('onclick', 'return false;');
        form.updating = true;

        let formData = new FormData(form);
        formData.append('kentico_update_form', 'true');

        let focus = nextFocusElement || document.activeElement;

        let onResponse = (event) => {
            if (!event.target.response.data) {
                let selectionStart = selectionEnd = null;
                if (focus && (focus.type === 'text' || focus.type === 'search' || focus.type === 'password' || focus.type === 'tel' || focus.type === 'url')) {
                    selectionStart = focus.selectionStart;
                    selectionEnd = focus.selectionEnd;
                }

                let currentScrollPosition = $(window).scrollTop();
                $(elementIdSelector).replaceWith(event.target.responseText);
                $(window).scrollTop(currentScrollPosition);

                if (focus.id) {
                    let newInput = document.getElementById(focus.id);
                    if (newInput) {
                        newInput.focus();
                        this.setCaretPosition(newInput, selectionStart, selectionEnd);
                    }
                }
            }
        };

        this.createRequest(form, formData, onResponse);
    }

    submitForm(event) {
        event.preventDefault();
        let form = event.target;
        let formData = new FormData(form);

        let onResponse = (event) => {
            let contentType = event.target.getResponseHeader('Content-Type');

            const { responseText } = event.target;
            const cleanText = responseText.length > 0 ? new DOMParser().parseFromString(responseText, 'text/html').body.textContent.trim() : 'We\'ve received your message and will be in touch shortly.';

            console.log(cleanText);
            if (contentType.indexOf('application/json') === -1) {
                let currentScrollPosition = $(window).scrollTop();

                // Replace content with thank you message
                $(form).html(
                    `<div class="thank-you-message">                        
                        <p>${cleanText}</p>
                    </div>`
                );

                $(window).scrollTop(currentScrollPosition);

                if (window.dataLayer !== undefined) {
                    window.dataLayer.push({
                        message: 'Thank you for contacting InnovAge',
                        event: 'Contact Us',
                    });
                }
                if (window.kentico && window.kentico.contactus) {
                    window.kentico.contactus.refreshEvents();
                }
            } else {
                let json = JSON.parse(event.target.response);
                window.location.href = json.redirectTo;
            }
        };

        this.createRequest(form, formData, onResponse);
    }

    createRequest(form, formData, onResponse) {
        let xhr = new XMLHttpRequest();

        xhr.addEventListener('load', onResponse);

        xhr.open('POST', form.action);
        xhr.send(formData);
    }

    /**
     * Sets the caret position.
     * @param {HTMLInputElement} input Input element in which the caret position should be set.
     * @param {number} selectionStart Selection start position.
     * @param {number} selectionEnd Selection end position.
     */
    setCaretPosition(input, selectionStart, selectionEnd) {
        if (selectionStart === null && selectionEnd === null) {
            return;
        }

        if (input.setSelectionRange) {
            input.setSelectionRange(selectionStart, selectionEnd);
        }
    }

    debounce(func, wait, immediate) {
        let timeout;

        return (...argums) => {
            let context = this;
            let args = argums;

            let later = () => {
                timeout = null;

                if (!immediate) {
                    func.apply(context, args);
                }
            };

            let callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait || 200);

            if (callNow) {
                func.apply(context, args);
            }
        };
    }
}

export default FormHelper;

window.kentico = window.kentico || {};
window.kentico.updatableFormHelper = new FormHelper();
